import TagManager from 'react-gtm-module';
import { useEffect } from 'react';

const GTagManager = ({ user, GOOGLE_ANALYTICS_CONTAINER_ID }) => {

    const applicationId = localStorage.getItem('ssapApplicationId');

    const tagManagerArgs = {
        gtmId: GOOGLE_ANALYTICS_CONTAINER_ID,
        dataLayer: {
            'event': 'pageViewGI',
            'pageName' : document.title,
            'pageCategory': 'Dashboard',
            'referringPageUrl': document.referrer,
            'destinationPageUrl': document.URL, 
            'userSignin': '',
            'getInsuredTool': 'Portal',
            'caseID': '',
            'userRole': '',
            'userDetailedRole': '',
            'applicationId': ''
        }
    };

    const gtmProps = {
        applicationId,
        tagManagerArgs
    };

    const getExternalIDs = ({ applicationId, tagManagerArgs }, initializeGTM) => {
        const url = '/hix/gtmData/' + applicationId;
        if( applicationId != null && applicationId != undefined && applicationId != '') {
            global.__ENV__.PRODUCTION && fetch(url)
                .then( res => {
                    return res.json();
                })
                .then( json => {
                    tagManagerArgs.dataLayer.caseID = json.externalHouseholdCaseId;
                    tagManagerArgs.dataLayer.applicationId = json.externalApplicationId;
                    initializeGTM(tagManagerArgs);
                })
                .catch( res => { console.log(res); initializeGTM(tagManagerArgs); });
        }
    };


    const initializeGTM = (tagManagerArgs)=> {
        TagManager.initialize(tagManagerArgs);
    };

    useEffect( ()=> {
        if(user) {

            const { role, userActiveRole } = user;
    
            tagManagerArgs.dataLayer.userRole = role;
            tagManagerArgs.dataLayer.userDetailedRole = userActiveRole;
            tagManagerArgs.dataLayer.userSignin = 'Signed In';

            if(applicationId === '') {
                setTimeout( () => {
                    const updateId = localStorage.getItem('ssapApplicationId');
                    gtmProps.applicationId = updateId;
                    getExternalIDs(gtmProps, initializeGTM); 
                }, 7000);
            } else {
                getExternalIDs(gtmProps, initializeGTM); 
            }
           
        } else {
            tagManagerArgs.dataLayer.userSignin = 'Not Signed In';
            localStorage.setItem('ssapApplicationId', '');
            initializeGTM(tagManagerArgs);
        }
    }, [user]);  

    return null;
};


export default GTagManager;